import {
  check_if_chat_window_open,
  get_chat_members,
  get_time,
  check_if_room_admin,
  send_message,
  check_if_contributor_active,
} from "./erpnext_chat_utils";
import ChatWindow from "./erpnext_chat_window";
import ChatSpace from "./erpnext_chat_space";
import ChatContactList from "./erpnext_chat_contact_list";
import { remove_chat_topic } from "./erpnext_chat_space";

export default class ChatInfo {

  constructor(opts) {
   
    
   
    this.chat_space = opts.chat_space;
    this.chat_status = opts.chat_status;
    this.roomtype = this.chat_space.profile.room_type;
    this.roomname = this.chat_space.profile.room_name;
    this.contact = this.chat_space.profile.contact;
    this.room = this.chat_space.profile.room;
    this.sub_channels = this.chat_space.all_sub_channels_for_contributor;
    this.avatar = this.chat_space.avatar_html;
    this.user = this.chat_space.profile.user;
    this.user_email = this.chat_space.profile.user_email;
    this.is_admin = 0;
    this.setup();
   
  }

  open_manage_popup() {
    const me = this;

    frappe.call({
        method: "clefincode_chat.api.api_1_3_4.api.get_contact_by_profile",
        args: { profile_id: me.roomname },
        callback(r) {
            if (r.message && r.message.results) {
                me.profile = r.message.results;
            }

         
            const d = new frappe.ui.Dialog({
                title: "Manage Contact Details",
                fields: [
                    { fieldtype: "HTML", fieldname: "contacts_table_html" },
                    { fieldtype: "Section Break" },
                    {
                        label: "Add New Row",
                        fieldname: "add_row",
                        fieldtype: "Button",
                        click: () => me.add_new_row(d)
                    }
                ],
                primary_action_label: "Save",
                primary_action: () => me.save_all_contacts(d)
            });

            me.render_contacts_table(d);
            d.show();
        }
    });
}

//---------------------------------------------
// Render Contact Table
//---------------------------------------------

render_contacts_table(dialog) {
    const me = this;

    let rows = "";
    this.profile.contact_details.forEach((cd, index) => {
        rows += `
            <tr data-index="${index}">
                <td>${cd.contact_type}</td>
                <td>${cd.contact_info}</td>
                <td><button class="btn btn-xs btn-secondary edit-row">Edit</button></td>
                <td><button class="btn btn-xs btn-danger delete-row">Delete</button></td>
            </tr>
        `;
    });

    const html = `
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Contact Info</th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>${rows}</tbody>
        </table>
    `;

    dialog.fields_dict.contacts_table_html.$wrapper.html(html);
    this.bind_row_events(dialog);
}
bind_row_events(dialog) {
    const me = this;

    dialog.$wrapper.find(".edit-row").on("click", function () {
        const index = $(this).closest("tr").data("index");
        me.edit_row(dialog, index);
    });

    dialog.$wrapper.find(".delete-row").on("click", function () {
        const index = $(this).closest("tr").data("index");
        me.delete_row(dialog, index);
    });
}

edit_row(dialog, index) {
    const me = this;
    const row = me.profile.contact_details[index];

    const d = new frappe.ui.Dialog({
        title: "Edit Contact Row",
        fields: [
            {
                label: "Contact Type",
                fieldname: "contact_type",
                fieldtype: "Select",
                options: ["Email", "Chat", "WhatsApp", "Messenger", "Instagram", "Telegram"],
                default: row.contact_type
            },
            {
                label: "Contact Info",
                fieldname: "contact_info",
                fieldtype: "Data",
                default: row.contact_info
            }
        ],
        primary_action_label: "Update",
        primary_action(values) {
            row.contact_type = values.contact_type;
            row.contact_info = values.contact_info;

            d.hide();
            me.render_contacts_table(); 
            dialog.hide();
        }
    });

    d.show();
}

//---------------------------------------------
// Delete Row
//---------------------------------------------

delete_row(dialog, index) {
    this.profile.contact_details.splice(index, 1);
    this.render_contacts_table(dialog);
}

//---------------------------------------------
// Add New Row Popup
//---------------------------------------------

add_new_row(dialog) {
    const me = this;

    const d = new frappe.ui.Dialog({
        title: "Add New Contact Row",
        fields: [
            {
                label: "Contact Type",
                fieldname: "contact_type",
                fieldtype: "Select",
                options: ["Email", "Chat","Phone" ,"WhatsApp", "Messenger", "Instagram", "Telegram"]
            },
            {
                label: "Contact Info",
                fieldname: "contact_info",
                fieldtype: "Data"
            }
        ],
        primary_action_label: "Add",
        primary_action(values) {
            me.profile.contact_details.push(values);
            d.hide();
            me.render_contacts_table(dialog);
        }
    });

    d.show();
}

save_all_contacts(dialog) {
    frappe.call({
        method: "clefincode_chat.api.api_1_3_1.api.update_profile_contacts",
        args: {
            profile_id: this.profile.profile_id,   // your correct ID field
            contact_details: this.profile.contact_details
        },
        callback: () => {
            frappe.show_alert("Contact details updated successfully");

            // this.get_contact_details(); 
            // //this.$chat_contact.remove();
            // this.setup(); 

            dialog.hide();
           
        }
    });
}
  setup() {
    this.$chat_info = $(document.createElement("div")).addClass("chat-info");
    this.setup_header();
    if (
      typeof this.chat_space.$wrapper.attr("data-room") != "undefined" ||
      this.roomtype == "Topic"
    ) {
      this.setup_body();
    } else {
      this.$chat_info.append(`<div class="p-4 chat-info-section mt-0">
    <div class="p-2 text-center avatar-info">
      ${this.avatar}
    </div>
    <div class="p-2 text-center roomname">
      <div>Contact</div>
      <div>${this.chat_space.$wrapper.attr("data-contact")}</div>
      
    </div>`);
      this.chat_space.$wrapper.append(this.$chat_info);
      this.$chat_info.find(".avatar-frame").css("font-size", "3.5em");

      const me = this;
      this.$chat_info.find(".exitMe").on("click", function () {
        me.chat_space.$wrapper.find(".chat-space").show();
        me.chat_space.$wrapper.find(".chat-info").remove();
      });
    }
  }

  setup_header() {
    var header = ``;
    header += `  <div class="infoheader p-4 d-flex  flex-row-reverse justify-content-end align-items-center">
    <span style="font-size:24px; margin-left: 8px;">`;
    if (this.roomtype == "Direct") {
      header += `Contact Info`;
    } else if (this.roomtype == "Group") {
      header += `Group Info`;
    } else if (this.roomtype == "Contributor") {
      header += `Contributor Info`;
    } else if (this.roomtype == "Guest") {
      header += `Guest Info`;
    } else if (this.roomtype == "Topic") {
      header += `Conversation Info`;
    }

    header += `</span><span class="exitMe">${frappe.utils.icon(
      "arrow-left",
      "lg"
    )}</span></div>`;
    this.$chat_info.append(header);
  }

  async setup_body() {
    var body = ``;
    body += `    
  <div class="p-4 chat-info-section mt-0">
    <div class="p-2 text-center avatar-info">
      ${this.avatar}
    </div>
    <div class="p-2 text-center roomname">`;
    if (this.roomtype == "Group") {
      body += `<span class="gname mr-1" name="gname">${this.roomname}</span>`;
      const checkemail = this.user_email;
      this.is_admin = await check_if_room_admin(this.room, checkemail);
      if (this.chat_space.profile.is_removed != 1) {
        if (this.is_admin == 1)
           {
          body += `<span class="edit" style="cursor:pointer;">${frappe.utils.icon(
            "edit",
            "md"
          )}</span>`;
        }
      }

      body += `
           
    <div class="p-2 text-center">
      Group: <span class="participants">${this.count_group_members(
        this.chat_space.chat_members
      )}</span> participants
    </div>
    `;
     body +=`<span class="toggle-search" title="Search" style="cursor:pointer;cursor:pointer;margin-right:8px; width:20px; height:20px; margin-left:8px;">${frappe.utils.icon("search", "sm")}</span>`;
    } else if (this.roomtype == "Direct") {
      body += `<div>${this.roomname}</div>`;
      const useremail = this.user_email;
      const room_emails3 = this.chat_space.chat_members;
      $.each(room_emails3, function () {
        if (useremail != this.email) {
          body += `<div>${this.email}</div>`;
        }
      });
       {
          body += `<span class="edit-profile" style="cursor:pointer;">${frappe.utils.icon(
            "edit",
            "md"
          )}</span>`;
          body +=`<span class="toggle-search" title="Search" style="cursor:pointer;cursor:pointer;margin-right:8px; width:20px; height:20px; margin-left:8px;">${frappe.utils.icon("search", "sm")}</span>`;

        }
    } else if (this.roomtype == "Contributor") {
      body += `<div>@Contributor</div>`;
    }
    body += `</div></div>`;
    if (this.roomtype == "Topic") {
      body = ``;
    }

    await this.$chat_info.append(body);
    this.chat_space.$wrapper.append(this.$chat_info);
    this.$chat_info.find(".avatar-frame").css("font-size", "3.5em");
    await this.setup_sections();
    this.setup_events();
  }

  async setup_sections() {
    const me = this;
    const isClosed = (this.chat_status || this.chat_space.chat_status) === "Closed";
    const media_links_docs_section = `  
  <div class="p-4 chat-info-section openMedia"  style="cursor: pointer;">Media, links and docs</div>
  <div class="p-4 chat-info-section" style="display:flex; justify-content:center;">
  <button
      class="btn btn-sm btn-danger close-channel"
      ${isClosed ? "disabled" : ""}
    >
      ${isClosed ? "Closed" : "Close Channel"}
  </button>
</div>

  <div class=" chat-media" 
  style="position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
 
  display:none;">
    <div class="p-4 medeiaheader closeMedia" style="cursor: pointer; border-bottom: 2px solid #f0f2f5;display: flex;align-items: center;" > <span class="back-to-chat-info" >${frappe.utils.icon(
      "arrow-left",
      "lg"
    )}</span> <span style="margin-left:8px;font-size:16px;">${
      this.roomname
    }</span></div>
    <div class="p-4 chat-info-section chat-media-tabs mt-0 d-flex flex-row"> 
      <span  class="infobutton openmediaTab active">Media</span>
      <span  class="infobutton openlinksTab">Links</span>
      <span  class="infobutton opendocsTab">Docs</span>
    </div>
    <div class="p-4 chat-info-section mediatab" style=" overflow: scroll;height: 420px;">
      <div id="mediatabcontainer" class="mediatabcontainer">
      </div>
    </div>
    <div class="p-4 chat-info-section linkstab" style="display:none;overflow: scroll;height: 420px;">
      <div id="linkstabcontainer" class="linkstabcontainer">
      </div>
    </div>
    <div class="p-4 chat-info-section docstab" style="display:none;overflow: scroll;height: 420px;">
      <div id="docstabcontainer" class="docstabcontainer">
      </div>
    </div>
  </div> `;

    const refernce_doctypes_section = this.render_refernce_doctypes_section();

    if (this.roomtype == "Group") {
      let group_sections = ``;
      const room1 = await get_room_creator(this.room);
      group_sections += `<div class="p-4 chat-info-section" >Group created by `;

      if (this.user_email == room1[0].channel_creator) {
        group_sections += `you`;
      } else {
        group_sections += `${room1[0].channel_creator_name}`;
      }

      group_sections += ` ,on ${room1[0].creation_date} at ${room1[0].creation_time}</div>`;
      group_sections += media_links_docs_section;

      var room_emails = await get_chat_members(this.room);
      if (room_emails.length > 0) {
        group_sections += `<div class="p-4 chat-info-section members-section"><div class="pb-2 font-weight-bold">Members</div>`;
          
      }
      const checkemail = this.user_email;
      if (this.chat_space.profile.is_removed != 1) {
        if (this.is_admin == 1) {
          group_sections += `
        <div class="add_members-button d-flex flex-row justify-content-between">
              <div class="add_members">${frappe.utils.icon(
                "assign",
                "md"
              )} Add members</div>
            </div>

            <div class="add-members-overlay">
              <div class="add-members-overlay-header">
                <span class="close_members_lis">${frappe.utils.icon("arrow-left", "lg")}</span>
                <span>Add members</span>
              </div>

              <input type="text" placeholder="Search.." class="myInput filter-members">

              <div class="list_members"></div>
            </div>
        `;
        }
      }

      group_sections += `<div class="list_present_members">`;
      $.each(room_emails, function () {
        if (this.is_admin == 1) {
          group_sections += `
        <div class="d-flex flex-row justify-content-between align-items-center pb-2 pt-2 delete-member" delete-data="${this.email}">
        <div >
          <div >${this.name} (Admin)</div>
          <div class="small">${this.email}</div>
        </div>
        `;
        } else {
          group_sections += `
        <div class="d-flex flex-row justify-content-between align-items-center pb-2 pt-2 delete-member" delete-data="${this.email}">
        <div >
          <div >${this.name}</div>
          <div class="small">${this.platform}: ${this.email}</div>
        </div>
        `;
        }

        if (me.chat_space.profile.is_removed != 1) {
          if (me.is_admin == 1) {
            group_sections += `<div class="deletefromgroup" style="cursor: pointer;${
              me.user_email == this.email ? "display:none" : "display:block"
            }" id="${this.email}" data-name="${
              this.name
            }"><?xml version="1.0" encoding="iso-8859-1"?>
          <svg height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
             viewBox="0 0 496.158 496.158" xml:space="preserve">
          <path style="fill:#E04F5F;" d="M0,248.085C0,111.063,111.069,0.003,248.075,0.003c137.013,0,248.083,111.061,248.083,248.082
            c0,137.002-111.07,248.07-248.083,248.07C111.069,496.155,0,385.087,0,248.085z"/>
          <path style="fill:#FFFFFF;" d="M383.546,206.286H112.612c-3.976,0-7.199,3.225-7.199,7.2v69.187c0,3.976,3.224,7.199,7.199,7.199
            h270.934c3.976,0,7.199-3.224,7.199-7.199v-69.187C390.745,209.511,387.521,206.286,383.546,206.286z"/>
          </svg></div>`;
          }
        }

        group_sections += `</div>`;
      });

      group_sections += `</div></div>`;
      if (this.chat_space.profile.is_removed != 1) {
        if (typeof this.chat_space.contributors != "undefined") {
          const con = this.chat_space.contributors;
          if (con.length > 0) {
            group_sections += `<div class="p-4 chat-info-section contributor-section">`;
            group_sections += `<div class="pb-2 font-weight-bold">On going contributors</div>`;
            if (room_emails.some((e) => e.email === checkemail && this.chat_space.profile.user_type != "website_user")) {
              $.each(con, function () {
                group_sections += `
              <div class="d-flex flex-row justify-content-between align-items-center pb-2">
                <div >
                  <div >${this.name}</div>
                  <div class="small">${this.email}</div>
                </div>
                <div class="delete-contributor" c-email="${
                  this.email
                }" style="cursor: pointer;">${frappe.utils.icon(
                  "close",
                  "md"
                )}</div>
              </div>`;
              });
            } else {
              $.each(con, function () {
                group_sections += `
              <div class="d-flex flex-row justify-content-between">
              <div >
                <div >${this.name}</div>
                <div class="small">${this.email}</div>
              </div>
              </div>`;
              });
            }

            group_sections += `</div>`;
          }
        }
        group_sections += refernce_doctypes_section;
        if(this.chat_space.profile.user_type == "system_user" || (this.chat_space.profile.user_type == "website_user" && !this.chat_space.profile.is_website_support_group)){
          group_sections += `<div class="p-4 chat-info-section exit-group d-flex" >
          <div style="display: flex;flex: none;justify-content: center;margin-right: 16px; color:#ea0038;">
            <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" class="" version="1.1" x="0px" y="0px" enable-background="new 0 0 24 24" xml:space="preserve"><path fill="currentColor" d="M16.6,8.1l1.2-1.2l5.1,5.1l-5.1,5.1l-1.2-1.2l3-3H8.7v-1.8h10.9L16.6,8.1z M3.8,19.9h9.1 c1,0,1.8-0.8,1.8-1.8v-1.4h-1.8v1.4H3.8V5.8h9.1v1.4h1.8V5.8c0-1-0.8-1.8-1.8-1.8H3.8C2.8,4,2,4.8,2,5.8v12.4 C2,19.1,2.8,19.9,3.8,19.9z"></path></svg>
          </div>
          <div style="box-sizing: border-box;
          display: flex;
          flex: 1 1 auto;
          align-items: center;
          height: 100%;
          overflow: hidden;padding-right: 30px; color:#ea0038;">Exit group</div>
          </div>
          `;
        }
        
      }

      this.$chat_info.append(group_sections);
    } else if (this.roomtype == "Contributor") {
      let contributor_sections = ``;
      contributor_sections += media_links_docs_section;
      var room_emails = this.chat_space.chat_members;
      if (room_emails.length > 0) {
        contributor_sections += `<div class="p-4 chat-info-section members-section"><div class="pb-2 font-weight-bold">Members</div><div>`;
      }

      $.each(room_emails, function () {
        contributor_sections += `
      <div class="d-flex flex-row justify-content-between align-items-center pb-2" >
      <div >
        <div >${this.name}</div>
        <div class="small">${this.email}</div>
      </div>
      `;
        contributor_sections += `</div>`;
      });
      contributor_sections += `</div></div>`;

      const checkemail2 = this.user_email;
      var room_emails4 = this.chat_space.chat_members;
      if (typeof this.chat_space.contributors != "undefined") {
        const con = this.chat_space.contributors;
        if (con.length > 0) {
          contributor_sections += `<div class="p-4 chat-info-section"  >`;
          contributor_sections += `<div class="pb-2 font-weight-bold">On going contributors</div>`;
          if (room_emails4.some((e) => e.email === checkemail2 && this.chat_space.profile.user_type != "website_user")) {
            $.each(con, function () {
              contributor_sections += `
            <div class="d-flex flex-row justify-content-between align-items-center pb-2">
              <div >
                <div >${this.name}</div>
                <div class="small">${this.email}</div>
              </div>
              <div class="delete-contributor" c-email="${
                this.email
              }" style="cursor: pointer;">${frappe.utils.icon(
                "close",
                "md"
              )}</div>
            </div>`;
            });
          } else {
            $.each(con, function () {
              contributor_sections += `
            <div class="d-flex flex-row justify-content-between">
            <div >
              <div >${this.name}</div>
              <div class="small">${this.email}</div>
            </div>
            </div>`;
            });
          }
          contributor_sections += `</div>`;
        }
        contributor_sections += refernce_doctypes_section;
        let is_active_contributor = await check_if_contributor_active(
          this.chat_space.last_active_sub_channel,
          this.user_email
        );

        if (is_active_contributor == 1) {
          contributor_sections += `<div style="cursor:pointer" class="p-4 chat-info-section leave-conversation d-flex" >
        <div style="display: flex;flex: none;justify-content: center;margin-right: 16px; color:#ea0038;">
          <svg viewBox="0 0 24 24" height="24" width="24" preserveAspectRatio="xMidYMid meet" class="" version="1.1" x="0px" y="0px" enable-background="new 0 0 24 24" xml:space="preserve"><path fill="currentColor" d="M16.6,8.1l1.2-1.2l5.1,5.1l-5.1,5.1l-1.2-1.2l3-3H8.7v-1.8h10.9L16.6,8.1z M3.8,19.9h9.1 c1,0,1.8-0.8,1.8-1.8v-1.4h-1.8v1.4H3.8V5.8h9.1v1.4h1.8V5.8c0-1-0.8-1.8-1.8-1.8H3.8C2.8,4,2,4.8,2,5.8v12.4 C2,19.1,2.8,19.9,3.8,19.9z"></path></svg>
        </div>
        <div style="box-sizing: border-box;
        display: flex;
        flex: 1 1 auto;
        align-items: center;
        height: 100%;
        overflow: hidden;padding-right: 30px; color:#ea0038;">Leave Conversation</div>
        </div>`;
        }
      }
      this.$chat_info.append(contributor_sections);
    } else if (this.roomtype == "Direct") {
      let direct_chat_sections = ``;
      direct_chat_sections += media_links_docs_section;

      const room_emails1 = this.chat_space.chat_members;
      const group_emails = [];

      $.each(room_emails1, function () {
        group_emails.push(this.email);
      });
      const groups_in_common = await get_room_in_common(
        group_emails[0],
        group_emails[1]
      );
      if (groups_in_common.length > 0) {
        direct_chat_sections += `
      <div class="p-4 chat-info-section"  >
        <div class="font-weight-bold">${groups_in_common.length} groups in common</div>
      `;
        $.each(groups_in_common, function () {
          direct_chat_sections += `
        <div class="common-group" data-channel="${this.name}" 
        data-channel-name="${this.channel_name}" 
        style="cursor: pointer;">${this.channel_name}</div>
        `;
        });
        direct_chat_sections += `</div>`;
      }

      const checkemail2 = this.user_email;
      var room_emails4 = this.chat_space.chat_members;
      if (typeof this.chat_space.contributors != "undefined") {
        const con = this.chat_space.contributors;
        if (con.length > 0) {
          direct_chat_sections += `<div class="p-4 chat-info-section"  >`;
          direct_chat_sections += `<div class="pb-2 font-weight-bold">On going contributors</div>`;
          if (room_emails4.some((e) => e.email === checkemail2 && this.chat_space.profile.user_type != "website_user")) {
            $.each(con, function () {
              direct_chat_sections += `
            <div class="d-flex flex-row justify-content-between align-items-center pb-2">
              <div >
                <div >${this.name}</div>
                <div class="small">${this.email}</div>
              </div>
              <div class="delete-contributor" c-email="${
                this.email
              }" style="cursor: pointer;">${frappe.utils.icon(
                "close",
                "md"
              )}</div>
            </div>`;
            });
          } else {
            $.each(con, function () {
              direct_chat_sections += `
            <div class="d-flex flex-row justify-content-between">
            <div >
              <div >${this.name}</div>
              <div class="small">${this.email}</div>
            </div>
            </div>`;
            });
          }
          direct_chat_sections += `</div>`;
        }
      }
      direct_chat_sections += refernce_doctypes_section;
      this.$chat_info.append(direct_chat_sections);
    } else if (this.roomtype == "Topic") {
      const topicName = this.chat_space.chat_topic_space || this.chat_space.chat_topic || this.chat_space.profile?.chat_topic || null;
      const topicSubject =
        this.chat_space.chat_topic_space_subject ||
        this.chat_space.chat_topic_subject ||
        this.chat_space.alternative_subject ||
        topicName;

      const topicColor =
        this.chat_space.activeMessageTopicColor ||
        this.chat_space.topicColorMap?.get(topicName) ||
        this.chat_space.getTopicColor?.(topicName) ||
        "#7c3aed";

      const topicIsPrivate =
        this.chat_space.is_private ??
        this.chat_space.profile?.is_private ??
        0;

      const topicVisibilityLabel = topicIsPrivate ? __("Private") : __("Public");

      const topicStatus =
        this.chat_space.topic_status ||
        this.chat_space.chat_topic_status ||
        this.chat_space.profile?.topic_status ||
        "Open";

      let topic_title_section = `
        <div class="p-4 chat-info-section topic-info-editor-section">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <div class="pb-2 font-weight-bold">${__("Topic")}</div>
              <div class="topic-info-subject" title="${frappe.utils.escape_html(topicName || "")}">
                ${frappe.utils.escape_html(topicSubject || topicName || "")}
              </div>
              ${
                topicName && topicSubject !== topicName
                  ? `<div class="small text-muted topic-info-name">${frappe.utils.escape_html(topicName)}</div>`
                  : ``
              }
            </div>

            <button type="button" class="btn btn-xs btn-secondary edit-topic-info">
              ${frappe.utils.icon("edit", "sm")}
            </button>
          </div>

          <div class="d-flex align-items-center mt-2">
            <span
              class="topic-info-color-dot"
              style="
                width:14px;
                height:14px;
                border-radius:50%;
                display:inline-block;
                background:${frappe.utils.escape_html(topicColor)};
                margin-right:8px;
                border:1px solid rgba(0,0,0,.12);
              "
            ></span>
            <span class="small text-muted">${frappe.utils.escape_html(topicColor || "")}</span>
          </div>

          <div class="d-flex align-items-center mt-2">
            <span style="margin-right:8px;">👁</span>
            <span class="small text-muted topic-info-visibility">
              ${frappe.utils.escape_html(topicVisibilityLabel)}
            </span>
          </div>

          <div class="d-flex align-items-center mt-2">
            <span class="small text-muted" style="margin-right:8px;">${__("Status")}:</span>
            <span class="small text-muted topic-info-status">
              ${frappe.utils.escape_html(topicStatus)}
            </span>
          </div>

          <div class="mt-3" style="display:flex; justify-content:center;">
            <button
              type="button"
              class="btn btn-sm btn-danger close-topic"
              ${topicStatus === "Closed" ? "disabled" : ""}
            >
              ${topicStatus === "Closed" ? __("Closed") : __("Close Topic")}
            </button>
          </div>
        </div>
      `;

      this.$chat_info.append(topic_title_section);

      this.$chat_info.append(this.renderTopicReferencesSection());

      const hasRefs =
        Array.isArray(this.chat_space.reference_doctypes) &&
        this.chat_space.reference_doctypes.length;

      if (!hasRefs && topicName && this.chat_space.fetchTopicDetails) {
        this.chat_space.fetchTopicDetails(topicName)
          .then((details) => {
            if (details?.references?.length) {
              this.chat_space.reference_doctypes = details.references;
              this.refreshTopicReferencesSection();
            }
          })
          .catch((e) => {
            console.warn("[ChatInfo] Failed to refresh topic references", e);
          });
      }

      this.$chat_info.append(`
        <div class="p-4 chat-info-section members-section topic-members-section">
          <div class="pb-2 font-weight-bold">${__("Members")}</div>
          <div class="small text-muted topic-members-loading">${__("Loading...")}</div>
        </div>
      `);
      this.loadTopicMembersSection?.();

      this.$chat_info.append(`
        <div class="p-4 chat-info-section topic-contributors-section">
          <div class="pb-2 font-weight-bold">${__("Contributors")}</div>
          <div class="small text-muted topic-contributors-loading">${__("Loading...")}</div>
        </div>
      `);
      this.loadTopicContributorsSection?.();
    } else if (this.roomtype == "Guest") {
        let guest_sections = ``;

        const isClosed = (this.chat_status || this.chat_space.chat_status) === "Closed";

          guest_sections += `
            <div class="p-4 chat-info-section openMedia" style="cursor: pointer;">Media, links and docs</div>
            <div class="p-4 chat-info-section" style="display:flex; justify-content:center;">
              <button class="btn btn-sm btn-danger close-channel" ${isClosed ? "disabled" : ""}>
                ${isClosed ? "Closed" : "Close Channel"}
              </button>
            </div>
          `;
        

        this.$chat_info.append(guest_sections);
      }
  }

  setup_events() {
    const me = this;
    var channel;
    if (me.roomtype == "Contributor") {
      channel = me.sub_channels;
    } else {
      channel = me.room;
    }

    this.$chat_info.find(".exitMe").on("click", function () {
      me.chat_space.$wrapper.find(".chat-space").show();
      me.chat_space.get_topic_info(channel);
      me.chat_space.$wrapper.find(".chat-info").remove();
    });

    
    // Close channel
    this.$chat_info.find(".close-channel").on("click", async () => {
      const room = this.chat_space.profile.room;
      
      await frappe.call({
        method: "clefincode_chat.api.api_1_2_1.api.trigger_chat_channel_status",
        args: {
          room: room,
          is_open: true
        }
      });
      this.chat_space.chat_status = "Closed";
      this.chat_status = "Closed";

      $(".close-chat-window").click();

      this.$chat_info.find(".close-channel").prop("disabled", true).text("Closed");


      const $btn = this.$chat_info.find(".close-channel");
      if (this.chat_space.chat_status === "Closed") {
        $btn.prop("disabled", true).text("Closed");
      } else {
        $btn.prop("disabled", false).text("Close Channel");
      }

    });

    // Close topic
    this.$chat_info.find(".close-topic").on("click", async () => {
      const topicName =
        this.chat_space.chat_topic_space ||
        this.chat_space.chat_topic ||
        this.chat_space.profile?.chat_topic;

      if (!topicName) {
        frappe.msgprint({
          title: __("Error"),
          message: __("No topic found."),
          indicator: "red"
        });
        return;
      }

      try {
        await frappe.call({
          method: "clefincode_chat.api.api_1_3_4.api.update_chat_topic_info",
          args: {
            chat_topic: topicName,
            topic_status: "Closed"
          }
        });

        this.applyUpdatedTopicInfo(
          topicName,
          this.chat_space.chat_topic_subject ||
            this.chat_space.chat_topic_space_subject ||
            this.chat_space.alternative_subject ||
            topicName,
          this.chat_space.activeMessageTopicColor ||
            this.chat_space.topicColorMap?.get(topicName) ||
            this.chat_space.getTopicColor?.(topicName),
          this.chat_space.is_private ??
            this.chat_space.profile?.is_private ??
            0,
          "Closed"
        );

        this.chat_space.topic_status = "Closed";
        this.chat_space.chat_topic_status = "Closed";

        if (this.chat_space.profile) {
          this.chat_space.profile.topic_status = "Closed";
        }

        if (this.chat_space.topicDetailsCache?.has(topicName)) {
          const cached = this.chat_space.topicDetailsCache.get(topicName);
          if (cached) {
            cached.topic_status = "Closed";
            cached.status = "Closed";
          }
        }

        if (this.chat_space.messageCache) {
          this.chat_space.messageCache.forEach((cached, key) => {
            if (
              cached.chat_topic === topicName ||
              cached.topic === topicName ||
              cached.chat_topic_space === topicName
            ) {
              cached.topic_status = "Closed";
              cached.chat_topic_status = "Closed";
              cached.status = "Closed";
            }
          });
        }

        const $topicElements = this.chat_space.$chat_space_container
          ? this.chat_space.$chat_space_container.find(
              `[data-topic-name="${topicName}"]`
            )
          : this.chat_space.$chat_space
            ? this.chat_space.$chat_space.find(
                `[data-topic-name="${topicName}"]`
              )
            : $();

        $topicElements.attr("data-topic-status", "Closed");

        this.chat_space.refreshTopicNavBar?.();
        this.chat_space.buildTopicMetaMap?.();
        this.chat_space.applyTopicVisibility?.();

        this.$chat_info.find(".close-topic").prop("disabled", true).text(__("Closed"));
         $(".close-chat-window").click();       
        frappe.show_alert({
          message: __("Topic closed"),
          indicator: "green"
        });
      } catch (e) {
        console.error("Failed to close topic", e);
        frappe.msgprint({
          title: __("Error"),
          message: __("Failed to close topic."),
          indicator: "red"
        });
      }
    });

    this.$chat_info.find(".back-to-chat-info").on("click", function () {
      me.chat_space.$wrapper.find(".chat-info").show();
    });

    this.$chat_info.find(".edit").on("click", function () {
      var d = new frappe.ui.Dialog({
        title: "Edit Group Name",
        fields: [
          {
            label: "New Group Name",
            fieldname: "new_group_name",
            fieldtype: "Data",
            length: 50,
            reqd: 1,
          },
        ],
        primary_action: async function () {
          var data = d.get_values();
          const newname = data.new_group_name;
          me.chat_space.profile.room_name = newname;
          me.$chat_info
            .closest(".chat-window[data-room='" + me.room + "']")
            .find(".gname")
            .text(newname);

          await frappe.call({
            method: "clefincode_chat.api.api_1_2_1.api.set_group_name",
            args: {
              room: me.room,
              newname: newname,
              last_active_sub_channel: me.chat_space.last_active_sub_channel,
            },
            callback: function (r) {
              if (!r.exc) {
                const content = `<div class="rename-group" data-template="rename_group_template">
              <span class="sender-user" data-user="${me.user_email}"></span><span> changed the subject to "${newname}" </span>
              </div>`;

                const message_info = {
                  content: content,
                  user: me.user,
                  room: me.room,
                  email: me.user_email,
                  is_first_message: 0,
                  sub_channel: me.chat_space.last_active_sub_channel,
                  message_type: "information",
                  message_template_type: "Rename Group",
                  chat_topic: me.chat_space.chat_topic,
                };
                send_message(message_info);
                d.hide();
              }
            },
          });
        },
        primary_action_label: "Edit",
      });
      d.show();
    });
    this.$chat_info.find(".edit-profile").on("click", function () {
    me.open_manage_popup();
});

  this.$chat_info.find(".toggle-search").on("click", () => {

  me.chat_space.$wrapper.find(".chat-space").show();  
  me.chat_space.$wrapper.find(".chat-info").remove(); 
  
  
  const $search =  me.chat_space.$wrapper.find(".chat-search");  
  $search.stop(true, true).slideToggle(150); 

  if ($search.is(":visible")) {
    setTimeout(() => {
      
      me.chat_space.$wrapper.find(".chat-search-input").focus();
    }, 0);
  } else {
   
    me.searchActive = false;
    me.searchQuery = null;
  }
});
    this.$chat_info.find(".leave-conversation").on("click", function () {
      frappe.confirm(
        "Are you sure you want to leave this conversation?",
        async () => {
          const content = `<div class="user-left" data-template="user_left_template">
      <span class="sender-user" data-user="${me.user_email}"></span><span> left </span>
      </div>`;

          const message_info = {
            content: content,
            user: me.user,
            room: me.chat_space.profile.parent_channel,
            email: me.user_email,
            sub_channel: me.chat_space.last_active_sub_channel,
            message_type: "information",
            message_template_type: "User Left",
            chat_topic: me.chat_space.chat_topic,
          };

          await send_message(message_info);

          let empty_contributor_list = 1;
          me.chat_space.contributors = me.chat_space.contributors.filter(
            (user) => user.email !== me.user_email
          );
          if (me.chat_space.contributors.length > 0) {
            empty_contributor_list = 0;
          }

          const params = {
            parent_channel: me.chat_space.profile.parent_channel,
            user: me.user,
            user_email: me.user_email,
            last_active_sub_channel: me.chat_space.last_active_sub_channel,
            user_to_remove: me.user_email,
            empty_contributor_list: empty_contributor_list,
          };
          leave_contributor(params);
          this.remove();
        }
      );
    });

    this.$chat_info.find(".exit-group").on("click", function () {
      frappe.confirm("Are you sure you want to exit this group?", async () => {
        const only_room_admin = await get_room_admins(me.room, me.user_email);
        const are_members = await is_member(
          me.room,
          me.chat_space.last_active_sub_channel
        );

        if (only_room_admin) {
          if (!are_members) {
            // Remove all contributors
            const last_active_sub_channel =
              me.chat_space.last_active_sub_channel;
            if (me.chat_space.contributors) {
              let emailList = me.chat_space.contributors.map(
                (user) => user.email
              );
              let emailListJson = JSON.stringify(emailList);

              let content = `
              <div class="remove-contributors" data-template="remove_contributors_template">
              <span class="sender-user" data-user="${me.user_email}"></span><span> removed all contributers</span>
              </div>`;

              const message_info = {
                content: content,
                user: me.user,
                room: channel,
                email: me.user_email,
                is_first_message: 0,
                sub_channel: me.chat_space.last_active_sub_channel,
                message_type: "information",
                message_template_type: "Remove Contributors",
              };
              await send_message(message_info);
              await disable_contributors(
                me.room,
                me.chat_space.last_active_sub_channel,
                emailListJson
              );
            }

            const content = `<div class="user-left" data-template="user_left_template">
            <span class="sender-user" data-user="${me.user_email}"></span><span> left </span>
            </div>`;
            const message_info = {
              content: content,
              user: me.user,
              room: me.chat_space.profile.room,
              email: me.user_email,
              is_first_message: 0,
              sub_channel: last_active_sub_channel,
              message_type: "information",
              message_template_type: "User Left",
            };
            await send_message(message_info);
            const res3 = await remove_group_member(
              me.user_email,
              me.room,
              me.chat_space.last_active_sub_channel
            );

            me.$chat_info.find(".add_members-button").remove();
            me.$chat_info
              .find(".delete-member[delete-data='" + me.user_email + "']")
              .remove();
            me.$chat_info.find(".delete-contributor").remove();
            me.$chat_info.find(".deletefromgroup").remove();
            me.$chat_info.find(".exit-group").remove();
            me.$chat_info.find(".contributor-section").remove();
            me.$chat_info
              .find(".participants")
              .html(me.count_group_members(me.chat_space.chat_members));
            me.$chat_info.find(".members-section").parent().remove();
            me.chat_space.profile.is_removed = 1;
            me.chat_space.$chat_actions.html(
              `<div class='text-center'>You can't send messages to this group because you're no longer a participant. </div>`
            );
          } else {
            var new_chat_members = $.grep(
              me.chat_space.chat_members,
              function (e) {
                return e.email != me.user_email;
              }
            );
            let d = new frappe.ui.Dialog({
              title: "Chose an admin for this group",
              fields: [
                {
                  label: "User",
                  fieldname: "user",
                  fieldtype: "Select",
                  options: new_chat_members.map(
                    (row) => row.name + ":" + row.email
                  ),
                  reqd: 1,
                },
              ],
              size: "small", // small, large, extra-large
              primary_action_label: "Submit",
              async primary_action(values) {
                const content = `<div class="user-left" data-template="user_left_template">
            <span class="sender-user" data-user="${me.user_email}"></span><span> left </span>
            </div>`;

                //  me.chat_space.$chat_space_container.append(
                //   await me.chat_space.make_message({
                //     content: content,
                //     type: 'info-message',
                //     sender: me.user,
                //     message_template_type: "User Left"
                //   }));

                let chat_room;
                if (me.chat_space.profile.room_type == "Contributor") {
                  chat_room = me.chat_space.profile.parent_channel;
                } else {
                  chat_room = me.chat_space.profile.room;
                }

                const message_info = {
                  content: content,
                  user: me.user,
                  room: chat_room,
                  email: me.user_email,
                  is_first_message: 0,
                  sub_channel: me.chat_space.last_active_sub_channel,
                  message_type: "information",
                  message_template_type: "User Left",
                  chat_topic: me.chat_space.chat_topic,
                };
                await send_message(message_info);

                var arr = values["user"].split(":");
                var new_admin_email = arr[arr.length - 1];

                me.is_admin = 0;

                const res33 = await remove_group_member_and_assign_new_admin(
                  me.user_email,
                  me.room,
                  new_admin_email,
                  me.chat_space.last_active_sub_channel
                );

                const new_admin_message = `<div class="set-user-admin" data-template="set_user_admin_template">
                  <span> You're now an admin</span>
                  <span class="receiver-user" data-user="${new_admin_email}"></span>
                </div>`;

                const admin_message_info = {
                  content: new_admin_message,
                  user: me.user,
                  room: chat_room,
                  email: me.user_email,
                  is_first_message: 0,
                  sub_channel: me.chat_space.last_active_sub_channel,
                  message_type: "information",
                  message_template_type: "Set Admin",
                  only_receive_by: new_admin_email,
                  chat_topic: me.chat_space.chat_topic,
                };
                send_message(admin_message_info);

                me.$chat_info.find(".edit").remove();
                me.$chat_info.find(".add_members-button").remove();
                me.$chat_info
                  .find(".delete-member[delete-data='" + me.user_email + "']")
                  .remove();
                me.$chat_info.find(".delete-contributor").remove();
                me.$chat_info.find(".deletefromgroup").remove();
                me.$chat_info.find(".exit-group").remove();
                me.$chat_info.find(".contributor-section").remove();
                me.$chat_info
                  .find(".participants")
                  .html(me.count_group_members(me.chat_space.chat_members));
                me.chat_space.$chat_actions.html(
                  `<div class='text-center'>You can't send messages to this group because you're no longer a participant. </div>`
                );
                d.hide();
              },
            });

            d.show();
          }
        } else {
          const content = `<div class="user-left" data-template="user_left_template">
          <span class="sender-user" data-user="${me.user_email}"></span><span> left </span>
            </div>`;

          //  me.chat_space.$chat_space_container.append(
          //   await me.chat_space.make_message({
          //     content: content,
          //     type: 'info-message',
          //     sender: me.user,
          //     message_template_type: "User Left"
          //   }));

          let chat_room;
          if (me.chat_space.profile.room_type == "Contributor") {
            chat_room = me.chat_space.profile.parent_channel;
          } else {
            chat_room = me.chat_space.profile.room;
          }

          const message_info = {
            content: content,
            user: me.user,
            room: chat_room,
            email: me.user_email,
            is_first_message: 0,
            sub_channel: me.chat_space.last_active_sub_channel,
            message_type: "information",
            message_template_type: "User Left",
            chat_topic: me.chat_space.chat_topic,
          };
          await send_message(message_info);

          const res3 = await remove_group_member(
            me.user_email,
            me.room,
            me.chat_space.last_active_sub_channel
          );

          me.$chat_info.find(".add_members-button").remove();
          me.$chat_info
            .find(".delete-member[delete-data='" + me.user_email + "']")
            .remove();
          me.$chat_info.find(".delete-contributor").remove();
          me.$chat_info.find(".deletefromgroup").remove();
          me.$chat_info.find(".exit-group").remove();
          me.$chat_info.find(".contributor-section").remove();
          me.$chat_info
            .find(".participants")
            .html(me.count_group_members(me.chat_space.chat_members));
          me.chat_space.profile.is_removed = 1;
          me.chat_space.$chat_actions.html(
            `<div class='text-center'>You can't send messages to this group because you're no longer a participant. </div>`
          );
        }
      });
    });

    $(document).on("click", function (event) {
      var $target = $(event.target);
      if ($target.closest(me.$chat_info.find(".deletefromgroup")).length) {
        var $this = $target.closest(me.$chat_info.find(".deletefromgroup"));
        frappe.confirm(
          "Are you sure you want to delete this member?",
          async () => {
            var id = $this.attr("id");

            let content = `
              <div class="remove-user" data-template="remove_user_template">
              <span class="sender-user" data-user="${
                me.user_email
              }"></span><span> removed </span><span class="receiver-user" data-user="${$this.attr(
              "id"
            )}"></span>
              </div>`;

            // me.chat_space.$chat_space_container.append(
            // await me.chat_space.make_message({
            //   content: content,
            //   type: 'info-message',
            //   sender: me.user,
            //   message_template_type: "Remove User"
            // }));

            let chat_room;
            if (me.chat_space.profile.room_type == "Contributor") {
              chat_room = me.chat_space.profile.parent_channel;
            } else {
              chat_room = me.chat_space.profile.room;
            }

            const message_info = {
              content: content,
              user: me.user,
              room: chat_room,
              email: me.user_email,
              is_first_message: 0,
              sub_channel: me.chat_space.last_active_sub_channel,
              message_type: "information",
              message_template_type: "Remove User",
              chat_topic: me.chat_space.chat_topic,
            };
            await send_message(message_info);
            const res3 = await remove_group_member(
              id,
              me.room,
              me.chat_space.last_active_sub_channel
            );

            me.$chat_info
              .find(".delete-member[delete-data='" + id + "']")
              .remove();
            me.$chat_info
              .find(".participants")
              .html(me.count_group_members(me.chat_space.chat_members));
          }
        );
      }
    });

    this.$chat_info.find(".openMedia").on("click", function () {
      me.$chat_info.find(".chat-media").css("display", "block");
      me.$chat_info.scrollTop("0");
      me.$chat_info.css("overflow", "hidden");
      me.$chat_info.css("height", "574px");
      me.$chat_info.find(".openmediaTab").click();
    });

    this.$chat_info.find(".closeMedia").on("click", function () {
      me.$chat_info.find(".chat-media").css("display", "none");
      me.$chat_info.css("overflow", "auto");
      me.$chat_info.css("height", "100%");
    });

    this.$chat_info.find(".delete-contributor").on("click", function () {
      const email = $(this).attr("c-email");
      me.chat_space.$chat_actions
        .find(".tag-blot[data-email='" + email + "'] .remove-tag")
        .click();

      $(this).parent().remove();
    });

    this.$chat_info.find(".remove-document").on("click", async function () {
      const reference_doctype = $(this).data("docname");
      const chat_channel =
        me.chat_space.profile.room_type == "Contributor"
          ? me.chat_space.profile.parent_channel
          : me.chat_space.profile.room;
      if (me.chat_space.reference_doctypes.length == 1) {
        var d = new frappe.ui.Dialog({
          title: "Confirm Action",
          fields: [
            {
              label: "Are you sure you want to proceed?",
              fieldtype: "HTML",
              options:
                "Removing this document will leave the topic empty. Do you wish to retain the topic in the chat with no content, or would you prefer to remove the entire topic from the chat?",
            },
          ],
          primary_action_label: "Remove",
          async primary_action() {
            let chat_topic_subject = "";
            if (me.chat_space.chat_topic_subject) {
              chat_topic_subject = me.chat_space.chat_topic_subject;
            } else {
              chat_topic_subject = me.chat_space.reference_doctypes[0].docname;
            }
            await remove_chat_topic(
              me.chat_space.chat_topic,
              chat_channel,
              me.chat_space.last_active_sub_channel
            );
            me.chat_space.send_remove_topic_message(
              chat_channel,
              chat_topic_subject
            );
            me.$chat_info.find(".reference-doctypes-section").remove();
            d.hide();
          },
          secondary_action_label: "Keep Empty",
          async secondary_action() {
            if (!me.chat_space.chat_topic_subject) {
              var dd = new frappe.ui.Dialog({
                title: "Set Topic Subject",
                fields: [
                  {
                    label: "New Subject",
                    fieldname: "chat_topic_subject",
                    fieldtype: "Data",
                    length: 25,
                    reqd: 1,
                  },
                ],
                primary_action: function () {
                  var data = dd.get_values();
                  frappe.call({
                    method:
                      "clefincode_chat.api.api_1_2_1.api.set_topic_subject",
                    args: {
                      chat_topic: me.chat_space.chat_topic,
                      new_subject: data.chat_topic_subject,
                      chat_channel: chat_channel,
                      last_active_sub_channel:
                        me.chat_space.last_active_sub_channel,
                    },
                    callback: async function (r) {
                      if (!r.exc) {
                        await me.chat_space.send_rename_topic_message(
                          data.chat_topic_subject,
                          chat_channel
                        );
                        remove_reference_doctype(
                          me.chat_space.chat_topic,
                          reference_doctype,
                          chat_channel,
                          me.chat_space.last_active_sub_channel
                        );
                        await me.send_remove_document_message(
                          reference_doctype,
                          chat_channel
                        );
                        $(this).parent().remove();
                        me.$chat_info
                          .find(".reference-doctypes-section")
                          .remove();
                        d.hide();
                        dd.hide();
                      }
                    },
                  });
                },
                primary_action_label: "Edit",
              }).show();
            } else {
              remove_reference_doctype(
                me.chat_space.chat_topic,
                reference_doctype,
                chat_channel,
                me.chat_space.last_active_sub_channel
              );
              await me.send_remove_document_message(
                reference_doctype,
                chat_channel
              );
              $(this).parent().remove();
              me.$chat_info.find(".reference-doctypes-section").remove();
              d.hide();
            }
          },
        }).show();
      } else {
        remove_reference_doctype(
          me.chat_space.chat_topic,
          reference_doctype,
          chat_channel,
          me.chat_space.last_active_sub_channel
        );
        await me.send_remove_document_message(reference_doctype, chat_channel);
        $(this).parent().remove();
      }
    });

    this.$chat_info.find(".openmediaTab").on("click", async function () {
      me.$chat_info.find(".infobutton").removeClass("active");
      $(this).addClass("active");
      me.$chat_info.find(".linkstab").css("display", "none");
      me.$chat_info.find(".docstab").css("display", "none");
      me.$chat_info.find(".mediatab").css("display", "block");

      const res = await get_media(
        channel,
        me.user_email,
        me.chat_space.profile.remove_date
      );
      if (res.length == 0) {
        me.$chat_info.find("#mediatabcontainer").html("No Media");
      } else {
        me.$chat_info.find("#mediatabcontainer").html("");
        $.each(res, function () {
          me.$chat_info.find("#mediatabcontainer").append(this.content);
        });
      }
    });

    this.$chat_info.find(".openlinksTab").on("click", async function () {
      me.$chat_info.find(".infobutton").removeClass("active");
      $(this).addClass("active");
      me.$chat_info.find(".mediatab").css("display", "none");
      me.$chat_info.find(".docstab").css("display", "none");
      me.$chat_info.find(".linkstab").css("display", "block");
      const res = await get_links(
        channel,
        me.useremail,
        me.chat_space.profile.remove_date
      );
      if (res.length == 0) {
        me.$chat_info.find("#linkstabcontainer").html("No Links");
      } else {
        me.$chat_info.find("#linkstabcontainer").html("");
        $.each(res, function () {
          const div = $(document.createElement("div")).addClass("linksrow");
          div.append(this.content);
          me.$chat_info.find("#linkstabcontainer").append(div);
        });
      }
    });

    this.$chat_info.find(".opendocsTab").on("click", async function () {
      me.$chat_info.find(".infobutton").removeClass("active");
      $(this).addClass("active");
      me.$chat_info.find(".mediatab").css("display", "none");
      me.$chat_info.find(".linkstab").css("display", "none");
      me.$chat_info.find(".docstab").css("display", "block");
      const res = await get_docs(
        channel,
        me.user_email,
        me.chat_space.profile.remove_date
      );
      if (res.length == 0) {
        me.$chat_info.find("#docstabcontainer").html("No Docs");
      } else {
        me.$chat_info.find("#docstabcontainer").html("");
        $.each(res, function () {
          me.$chat_info.find("#docstabcontainer").append(this.content);
        });
      }
    });

    this.$chat_info.find(".common-group").on("click", function (e) {
      const channel = $(e.target).attr("data-channel");
      const channel_name = $(e.target).attr("data-channel-name");
      me.open_chat_space(channel, channel_name);
    });

   this.$chat_info.find(".add_members").on("click", async function () {
            const isWebView = $("body").hasClass("cc-chat-webview");

            if (isWebView) {
              me.$chat_info.addClass("add-members-open");
              me.$chat_info.find(".add-members-overlay").show();
              me.$chat_info.find(".filter-members").show().val("").focus();
              me.$chat_info.find(".list_members").html("");
              me.$chat_info.find(".close_members_lis").css("visibility", "visible");
            } else {
              me.$chat_info.removeClass("add-members-open");
              me.$chat_info.find(".add-members-overlay").hide();
              me.$chat_info.find(".filter-members").hide().val("");
              me.$chat_info.find(".list_members").html("");
              me.$chat_info.find(".close_members_lis").css("visibility", "hidden");
            }

            me.add_member_list = new ChatContactList({
              $wrapper: me.chat_space.$wrapper,
              profile: me.chat_space.profile,
              chat_info: me,
              add_member: 1,
            });

            if (me.add_member_list.ready) {
              await me.add_member_list.ready;
            }

            me.add_member_list.render();
});

    this.$chat_info.find(".close_members_lis").on("click", function () {
  const list_of_members = me.$chat_info.find(".list_members");

  me.$chat_info.removeClass("add-members-open");
  me.$chat_info.find(".add-members-overlay").hide();

  list_of_members.html("");
  $(this).css("visibility", "hidden");
  me.$chat_info.find(".filter-members").css("display", "none").val("");

  me.add_member_list = null;
});

    this.$chat_info.find(".filter-members").on("keyup", function () {
      var input, filter, members_to_add, i, txtValue;
      input = $(this);
      filter = $(this).val().toUpperCase();

      members_to_add = me.$chat_info.find(".add_this_member");
      for (i = 0; i < members_to_add.length; i++) {
        txtValue = members_to_add[i].textContent || members_to_add[i].innerText;

        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          members_to_add[i].style.display = "";
        } else {
          members_to_add[i].style.display = "none";
        }
      }
    });

    this.$chat_info.find(".edit-topic-info").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      me.openEditTopicInfoDialog();
    });

    this.$chat_info.find(".add-topic-reference").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      me.openAddTopicReferenceDialog();
    });

    this.$chat_info.find(".remove-topic-reference").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $btn = $(this);
      const referenceDoctype = $btn.attr("data-reference-doctype");
      const referenceDocname = $btn.attr("data-reference-docname");

      me.removeTopicReference(referenceDoctype, referenceDocname);
    });
  } // end of setup_events

  openEditTopicInfoDialog() {
    const me = this;

    const topicName =
      this.chat_space.chat_topic_space ||
      this.chat_space.chat_topic ||
      this.chat_space.profile?.chat_topic;

    if (!topicName) {
      frappe.msgprint({
        title: __("Error"),
        message: __("No topic found."),
        indicator: "red"
      });
      return;
    }

    const currentSubject =
      this.chat_space.chat_topic_space_subject ||
      this.chat_space.chat_topic_subject ||
      this.chat_space.alternative_subject ||
      topicName;

    const currentColor =
      this.chat_space.activeMessageTopicColor ||
      this.chat_space.topicColorMap?.get(topicName) ||
      this.chat_space.getTopicColor?.(topicName) ||
      "#7c3aed";

    const currentIsPrivate =
      this.chat_space.is_private ??
      this.chat_space.profile?.is_private ??
      0;

    const currentStatus =
      this.chat_space.topic_status ||
      this.chat_space.chat_topic_status ||
      this.chat_space.profile?.topic_status ||
      "Open";

    const d = new frappe.ui.Dialog({
      title: __("Edit Topic"),
      fields: [
        {
          label: __("Subject"),
          fieldname: "subject",
          fieldtype: "Data",
          reqd: 1,
          default: currentSubject
        },
        {
          label: __("Color"),
          fieldname: "topic_color",
          fieldtype: "Color",
          default: currentColor
        },
        {
          label: __("Private"),
          fieldname: "is_private",
          fieldtype: "Check",
          default: currentIsPrivate ? 1 : 0,
          description: __("Checked = Private, unchecked = Public")
        },
        {
          label: __("Status"),
          fieldname: "topic_status",
          fieldtype: "Select",
          options: ["Open", "Closed"],
          default: currentStatus
        }
      ],
      primary_action_label: __("Save"),
      async primary_action(values) {
        if (!values.subject) {
          frappe.msgprint({
            title: __("Missing Subject"),
            message: __("Please enter a topic subject."),
            indicator: "orange"
          });
          return;
        }

        const existingReferences = Array.isArray(me.chat_space.reference_doctypes)
          ? [...me.chat_space.reference_doctypes]
          : [];

        try {
          const r = await frappe.call({
            method: "clefincode_chat.api.api_1_3_4.api.update_chat_topic_info",
            args: {
              chat_topic: topicName,
              subject: values.subject,
              topic_color: values.topic_color,
              is_private: values.is_private ? 1 : 0,
              topic_status: values.topic_status
            }
          });

          const updated = r.message || {};
          const newSubject =
            updated.chat_topic_subject ||
            updated.subject ||
            values.subject ||
            topicName;

          const newColor =
            updated.topic_color ||
            values.topic_color ||
            currentColor;

          const newIsPrivate =
            updated.is_private !== undefined
              ? updated.is_private
              : values.is_private ? 1 : 0;

          const newStatus =
            updated.topic_status ||
            values.topic_status ||
            currentStatus;

          if (
            Array.isArray(updated.reference_doctypes) &&
            updated.reference_doctypes.length
          ) {
            me.chat_space.reference_doctypes = updated.reference_doctypes;
          } else if (existingReferences.length) {
            me.chat_space.reference_doctypes = existingReferences;
          }

          const oldSubject = currentSubject;
          me.applyUpdatedTopicInfo(
            topicName,
            newSubject,
            newColor,
            newIsPrivate,
            newStatus
          );

          if (me.chat_space.fetchTopicDetails) {
            const details = await me.chat_space.fetchTopicDetails(topicName);

            if (details?.references?.length) {
              me.chat_space.reference_doctypes = details.references;
            }
          }

          if (newSubject !== oldSubject && me.chat_space.send_rename_topic_message) {
            const chatChannel =
              me.chat_space.chat_topic_channel ||
              me.chat_space.profile.room;

            await me.chat_space.send_rename_topic_message(newSubject, chatChannel);
          }

          frappe.show_alert({
            message: __("Topic updated"),
            indicator: "green"
          });

          d.hide();
        } catch (e) {
          console.error("Failed to update topic", e);
          frappe.msgprint({
            title: __("Error"),
            message: __("Failed to update topic."),
            indicator: "red"
          });
        }
      }
    });

    d.show();
  }

  applyUpdatedTopicInfo(topicName, subject, color, isPrivate = 0, status = "Open") {
    if (!topicName) return;

    const normalizedIsPrivate =
      isPrivate === 1 ||
      isPrivate === true ||
      isPrivate === "1" ||
      isPrivate === "true";

    const existingReferences = Array.isArray(this.chat_space.reference_doctypes)
      ? [...this.chat_space.reference_doctypes]
      : [];

    const safeSubject =
      typeof subject === "object"
        ? String(
            subject.chat_topic_subject ||
            subject.subject ||
            subject.topic_subject ||
            subject.name ||
            topicName ||
            ""
          )
        : String(subject || topicName || "");

    this.chat_space.chat_topic_space_subject = safeSubject;
    this.chat_space.chat_topic_subject = safeSubject;
    this.chat_space.alternative_subject = safeSubject;

    if (this.chat_space.profile) {
      this.chat_space.profile.room_name = safeSubject;
      this.chat_space.profile.chat_topic_subject = safeSubject;
    }

    this.chat_space.is_private = normalizedIsPrivate ? 1 : 0;
    this.chat_space.topic_status = status;
    this.chat_space.chat_topic_status = status;

    if (this.chat_space.profile) {
      this.chat_space.profile.is_private = normalizedIsPrivate ? 1 : 0;
      this.chat_space.profile.topic_status = status;
    }

    if (color) {
      this.chat_space.activeMessageTopicColor = color;

      if (this.chat_space.topicColorMap) {
        this.chat_space.topicColorMap.set(topicName, color);
      }
    }

    if (
      (!Array.isArray(this.chat_space.reference_doctypes) ||
        !this.chat_space.reference_doctypes.length) &&
      existingReferences.length
    ) {
      this.chat_space.reference_doctypes = existingReferences;
    }

    this.$chat_info.find(".topic-info-subject").text(safeSubject);
    this.$chat_info.find(".topic-info-subject").attr("title", topicName);
    this.$chat_info.find(".topic-info-color-dot").css("background", color);

    const $colorText = this.$chat_info.find(".topic-info-color-dot").next(".small");
    if ($colorText.length) {
      $colorText.text(color || "");
    }

    this.$chat_info
      .find(".topic-info-visibility")
      .html(normalizedIsPrivate ? __("Private") : __("Public"));

    this.$chat_info
      .find(".topic-info-status")
      .text(status || "");

    const shortTitle =
      safeSubject.length > 25
        ? safeSubject.substring(0, 25) + "..."
        : safeSubject;

    this.chat_space.$chat_space
      .find(".chat-profile-name")
      .text(shortTitle)
      .attr("title", safeSubject);

    if (color && this.chat_space.refreshTopicColor) {
      this.chat_space.refreshTopicColor(topicName);
    } else {
      this.updateTopicColorInDom(topicName, color);
    }

    if (color) {
      this.chat_space.applyTopicHeaderBorderColor?.(topicName, color);
    }

    this.updateTopicSubjectInDom(topicName, safeSubject);

    this.chat_space.buildTopicMetaMap?.();
    this.chat_space.refreshTopicNavBar?.();
    this.chat_space.normalizeTopicSeparators?.();
    this.chat_space.applyTopicVisibility?.();
  }

  updateTopicSubjectInDom(topicName, subject) {
    if (!topicName || !this.chat_space?.$chat_space) return;

    const safe = this.chat_space.escapeSelectorValue
      ? this.chat_space.escapeSelectorValue(topicName)
      : String(topicName).replace(/"/g, '\\"');

    this.chat_space.$chat_space
      .find(`[data-topic-name="${safe}"]`)
      .attr("data-topic-subject", subject);

    this.chat_space.$chat_space
      .find(`.chat-topic-separator[data-topic-name="${safe}"] .topic-separator-title`)
      .text(subject);

    this.chat_space.$chat_space
      .find(`.message-bubble[data-topic-name="${safe}"]`)
      .attr("title", `${__("Topic")}: ${subject}`);

    this.chat_space.$chat_space
      .find(`.topic-select-main[data-topic-name="${safe}"]`)
      .attr("data-topic-subject", subject)
      .find(".topic-select-title")
      .text(subject);
  }

  updateTopicColorInDom(topicName, color) {
    if (!topicName || !color || !this.chat_space?.$chat_space) return;

    const safe = this.chat_space.escapeSelectorValue
      ? this.chat_space.escapeSelectorValue(topicName)
      : String(topicName).replace(/"/g, '\\"');

    this.chat_space.$chat_space
      .find(`[data-topic-name="${safe}"]`)
      .attr("data-topic-color", color)
      .css("--topic-color", color);

    this.chat_space.$chat_space
      .find(`[data-topic-name="${safe}"] .message-topic-bar`)
      .css("background", color);

    this.chat_space.$chat_space
      .find(`.topic-select-main[data-topic-name="${safe}"]`)
      .attr("data-topic-color", color);

    this.chat_space.$chat_space
      .find(`.topic-select-row[data-topic-name="${safe}"] .topic-dot`)
      .css("background", color);
  }

  async loadTopicMembersSection() {
    const topicChannel =
      this.chat_space.chat_topic_channel ||
      this.chat_space.profile?.room ||
      this.room;

    const $section = this.$chat_info.find(".topic-members-section");

    if (!$section.length) return;

    if (!topicChannel) {
      $section.find(".topic-members-loading").text(__("No channel found"));
      return;
    }

    try {
      const chat_members = await get_chat_members(topicChannel);

      const rows = chat_members.length
        ? chat_members.map((member) => `
            <div class="d-flex flex-row justify-content-between pb-2">
              <div>
                <div>${frappe.utils.escape_html(member.name == frappe.session.user ? "You" : member.name)}</div>
                <div class="small">${frappe.utils.escape_html(member.email || "")}</div>
              </div>
            </div>
          `).join("")
        : `<div class="small text-muted">${__("No members")}</div>`;

      $section.find(".topic-members-loading").replaceWith(rows);
    } catch (e) {
      console.warn("[ChatInfo] Failed to load topic members", e);
      $section.find(".topic-members-loading").text(__("Failed to load members"));
    }
  }

  async loadTopicContributorsSection() {
    const topicName =
      this.chat_space.chat_topic_space ||
      this.chat_space.chat_topic ||
      this.chat_space.profile?.chat_topic;

    const $section = this.$chat_info.find(".topic-contributors-section");

    if (!$section.length) return;

    if (!topicName) {
      $section.remove();
      return;
    }

    try {
      const contributors = await get_topic_contributors(topicName);

      if (!contributors || !contributors.length) {
        $section.remove();
        return;
      }

      const rows = contributors.map((c) => `
        <div class="d-flex flex-row justify-content-between pb-2">
          <div>
            <div>${frappe.utils.escape_html(c.email == frappe.session.user ? "You" : c.name)}</div>
            <div class="small">${frappe.utils.escape_html(c.email || "")}</div>
          </div>
        </div>
      `).join("");

      $section.find(".topic-contributors-loading").replaceWith(rows);
    } catch (e) {
      console.warn("[ChatInfo] Failed to load topic contributors", e);
      $section.remove();
    }
  }

  renderTopicReferencesSection() {
    const refs = Array.isArray(this.chat_space.reference_doctypes)
      ? this.chat_space.reference_doctypes
      : [];

    const rows = refs.length
      ? refs.map((ref) => {
          const doctype = ref.doctype || ref.reference_doctype || "";
          const docname = ref.docname || ref.reference_docname || "";

          const safeDoctype = frappe.utils.escape_html(doctype);
          const safeDocname = frappe.utils.escape_html(docname);

          return `
            <div class="topic-reference-row d-flex flex-row justify-content-between align-items-center pb-2"
                 data-reference-doctype="${safeDoctype}"
                 data-reference-docname="${safeDocname}">
              <div>
                <div>${safeDoctype}</div>
                <div class="small">${safeDocname}</div>
              </div>

              <button
                type="button"
                class="btn btn-xs remove-topic-reference topic-reference-delete-btn"
                data-reference-doctype="${safeDoctype}"
                data-reference-docname="${safeDocname}"
                title="${__("Remove Reference")}"
              >
                ${frappe.utils.icon("delete-active", "sm")}
              </button>
            </div>
          `;
        }).join("")
      : `<div class="small text-muted">${__("No references")}</div>`;

    return `
      <div class="p-4 chat-info-section topic-references-section">
        <div class="d-flex justify-content-between align-items-center pb-2">
          <div class="font-weight-bold">${__("References")}</div>
          <button type="button" class="btn btn-xs btn-secondary add-topic-reference">
            ${__("Add")}
          </button>
        </div>
        ${rows}
      </div>
    `;
  }

  refreshTopicReferencesSection() {
    const $old = this.$chat_info.find(".topic-references-section");
    const html = this.renderTopicReferencesSection();

    if ($old.length) {
      $old.replaceWith(html);
    } else {
      this.$chat_info.append(html);
    }

    this.$chat_info.find(".add-topic-reference").off("click").on("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.openAddTopicReferenceDialog();
    });

    this.$chat_info.find(".remove-topic-reference").off("click").on("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const $btn = $(e.currentTarget);
      const referenceDoctype = $btn.attr("data-reference-doctype");
      const referenceDocname = $btn.attr("data-reference-docname");

      this.removeTopicReference(referenceDoctype, referenceDocname);
    });
  }

  openAddTopicReferenceDialog() {
    const me = this;

    const topicName =
      this.chat_space.chat_topic_space ||
      this.chat_space.chat_topic ||
      this.chat_space.profile?.chat_topic;

    if (!topicName) {
      frappe.msgprint({
        title: __("Error"),
        message: __("No topic found."),
        indicator: "red"
      });
      return;
    }

    const d = new frappe.ui.Dialog({
      title: __("Add Topic Reference"),
      fields: [
        {
          label: __("DocType"),
          fieldname: "reference_doctype",
          fieldtype: "Link",
          options: "DocType",
          reqd: 1
        },
        {
          label: __("Document"),
          fieldname: "reference_docname",
          fieldtype: "Dynamic Link",
          options: "reference_doctype",
          reqd: 1
        }
      ],
      primary_action_label: __("Add"),
      async primary_action(values) {
        if (!values.reference_doctype || !values.reference_docname) {
          frappe.msgprint({
            title: __("Missing values"),
            message: __("Please select DocType and Document."),
            indicator: "orange"
          });
          return;
        }

        try {
          const r = await frappe.call({
            method: "clefincode_chat.api.api_1_3_4.api.add_chat_topic_reference",
            args: {
              chat_topic: topicName,
              reference_doctype: values.reference_doctype,
              reference_docname: values.reference_docname
            }
          });

          const updated = r.message || {};
          const refs =
            updated.reference_doctypes ||
            updated.references ||
            [];

          if (Array.isArray(refs)) {
            me.chat_space.reference_doctypes = refs;
          }

          if (me.chat_space.messageCache) {
            me.chat_space.messageCache.forEach((cached) => {
              if (
                cached.chat_topic === topicName ||
                cached.topic === topicName
              ) {
                cached.reference_doctypes = refs;
                cached.references = refs;
              }
            });
          }

          me.refreshTopicReferencesSection();

          frappe.show_alert({
            message: __("Reference added"),
            indicator: "green"
          });

          d.hide();
        } catch (e) {
          console.error("Failed to add topic reference", e);
          frappe.msgprint({
            title: __("Error"),
            message: __("Failed to add reference."),
            indicator: "red"
          });
        }
      }
    });

    d.show();
  }

  removeTopicReference(referenceDoctype, referenceDocname) {
    const me = this;

    const topicName =
      this.chat_space.chat_topic_space ||
      this.chat_space.chat_topic ||
      this.chat_space.profile?.chat_topic;

    if (!topicName || !referenceDoctype || !referenceDocname) {
      frappe.msgprint({
        title: __("Error"),
        message: __("Missing topic or reference."),
        indicator: "red"
      });
      return;
    }

    frappe.confirm(
      __("Remove this reference?"),
      async () => {
        try {
          const r = await frappe.call({
            method: "clefincode_chat.api.api_1_3_4.api.remove_chat_topic_reference",
            args: {
              chat_topic: topicName,
              reference_doctype: referenceDoctype,
              reference_docname: referenceDocname
            }
          });

          const updated = r.message || {};
          const refs =
            updated.reference_doctypes ||
            updated.references ||
            [];

          me.chat_space.reference_doctypes = Array.isArray(refs) ? refs : [];

          if (me.chat_space.topicDetailsCache?.has(topicName)) {
            const cached = me.chat_space.topicDetailsCache.get(topicName) || {};
            cached.references = refs;
            cached.reference_doctypes = refs;
            me.chat_space.topicDetailsCache.set(topicName, cached);
          }

          if (me.chat_space.messageCache) {
            me.chat_space.messageCache.forEach((cached) => {
              if (
                cached.chat_topic === topicName ||
                cached.topic === topicName
              ) {
                cached.reference_doctypes = refs;
                cached.references = refs;
              }
            });
          }

          me.refreshTopicReferencesSection();

          frappe.show_alert({
            message: __("Reference removed"),
            indicator: "green"
          });
        } catch (e) {
          console.error("Failed to remove topic reference", e);
          frappe.msgprint({
            title: __("Error"),
            message: __("Failed to remove reference."),
            indicator: "red"
          });
        }
      }
    );
  }

  open_chat_space(channel, channel_name, roome_type = "Group") {
    if (check_if_chat_window_open(channel, "room")) {
      $(".expand-chat-window[data-id|='" + channel + "']").click();
      return;
    }

    let chat_window = new ChatWindow({
      profile: {
        room: channel,
      },
    });

    let profile = {
      is_admin: true,
      user: this.user,
      user_email: frappe.session.user,
      room: channel,
      room_name: channel_name,
      room_type: roome_type,
      is_first_message: 0,
      platform: "Chat",
    };
    new ChatSpace({
      $wrapper: chat_window.$chat_window,
      profile: profile,
      chat_status: this.chat_status,
    });
  }

  count_group_members(members) {
    const uniqueProfileIds = new Set();

    for (const member of members) {
      uniqueProfileIds.add(member.profile_id);
    }

    return uniqueProfileIds.size;
  }

  render_topic_section() {
    if (this.chat_space.chat_topic) {
      const topic_section = `
      <div class="p-4 chat-info-section topic-section">
        <div class="pb-2 font-weight-bold">Related Topic</div>
        
      </div>
    `;
    }
  }

  render_refernce_doctypes_section() {
    if (this.chat_space.reference_doctypes.length > 0) {
      const create_refernce_doctype = (doctype, show_delete) => `
      <div class="d-flex flex-row justify-content-between pb-2">
        <div>
          <div>${doctype.doctype}</div>
          <div class="small">${doctype.docname}</div>
        </div>
        ${
          show_delete
            ? `<div class="remove-document" data-docname ="${
                doctype.docname
              }" style="cursor: pointer;">${frappe.utils.icon(
                "delete-active",
                "md"
              )}</div>`
            : ""
        }
      </div>
      `;

      const show_delete = this.chat_space.chat_members.some(
        (e) => e.email === this.user_email && this.chat_space.profile.user_type != "website_user"
      );
      const refernces_doctypes = this.chat_space.reference_doctypes
        .map((doctype) => create_refernce_doctype(doctype, show_delete))
        .join("");

      const refernce_doctypes_section = `
      <div class="p-4 chat-info-section reference-doctypes-section">
        <div class="pb-2 font-weight-bold">References Doctypes</div>
        ${refernces_doctypes}
      </div>
      `;
      return refernce_doctypes_section;
    } else {
      return ``;
    }
  }

  async send_remove_document_message(docname, chat_channel) {
    const mention_msg_info = `
    <div class="remove-doctype" data-template = "remove_doctype_template">
    <span class="sender-user" data-user="${this.user_email}"></span><span> removed ${docname} </span>
    </div>`;

    const message_info = {
      content: mention_msg_info,
      user: this.user,
      room: chat_channel,
      email: this.user_email,
      message_type: "information",
      send_date: get_time(
        frappe.datetime.now_time(),
        this.chat_space.profile.time_zone
      ),
      message_template_type: "Remove Doctype",
      sub_channel: this.chat_space.last_active_sub_channel,
      chat_topic: this.chat_space.chat_topic,
    };

    await send_message(message_info);
  }
} // END Class

async function get_room_creator(room) {
  const res = await frappe.call({
    type: "GET",
    method: "clefincode_chat.api.api_1_2_1.api.get_room_creator",
    args: {
      room: room,
    },
  });
  return await res.message;
}

async function get_room_in_common(email1, email2) {
  const res = await frappe.call({
    type: "GET",
    method: "clefincode_chat.api.api_1_2_1.api.get_room_in_common",
    args: {
      email1: email1,
      email2: email2,
    },
  });
  return await res.message.results[0].results;
}

async function get_links(channel, useremail, remove_date) {
  const res = await frappe.call({
    method: "clefincode_chat.api.api_1_2_1.api.get_chat_links",
    args: {
      channel: channel,
      useremail: useremail,
      remove_date: remove_date,
    },
  });
  return await res.message.results[0].results;
}

async function get_media(channel, useremail, remove_date) {
  const res = await frappe.call({
    method: "clefincode_chat.api.api_1_2_1.api.get_chat_media",
    args: {
      channel: channel,
      useremail: useremail,
      remove_date: remove_date,
    },
  });
  return await res.message.results[0].results;
}

async function get_docs(channel, useremail, remove_date) {
  const res = await frappe.call({
    method: "clefincode_chat.api.api_1_2_1.api.get_chat_docs",
    args: {
      channel: channel,
      useremail: useremail,
      remove_date: remove_date,
    },
  });
  return await res.message.results[0].results;
}

async function remove_group_member(email, room, last_active_sub_channel) {
  const res = await frappe.call({
    method: "clefincode_chat.api.api_1_2_1.api.remove_group_member",
    args: {
      email: email,
      room: room,
      last_active_sub_channel: last_active_sub_channel,
    },
  });
  // return await res.message;
}

async function remove_group_member_and_assign_new_admin(
  email,
  room,
  new_admin_email,
  last_active_sub_channel
) {
  const res = await frappe.call({
    method:
      "clefincode_chat.api.api_1_2_1.api.remove_group_member_and_assign_new_admin",
    args: {
      email: email,
      room: room,
      new_admin_email: new_admin_email,
      last_active_sub_channel: last_active_sub_channel,
    },
  });
  // return await res.message;
}

async function get_room_admins(room, email) {
  const res = await frappe.call({
    method: "clefincode_chat.api.api_1_2_1.api.get_room_admins",
    args: {
      room: room,
      email: email,
    },
  });
  return await res.message;
}

async function is_member(room) {
  const res = await frappe.call({
    method: "clefincode_chat.api.api_1_2_1.api.are_members",
    args: {
      room: room,
    },
  });
  return await res.message;
}
async function disable_contributors(
  parent_channel,
  last_active_sub_channel,
  user_to_remove_list
) {
  const res = await frappe.call({
    type: "GET",
    method: "clefincode_chat.api.api_1_2_1.api.disable_contributors",
    args: {
      parent_channel: parent_channel,
      last_active_sub_channel: last_active_sub_channel,
      user_to_remove_list: user_to_remove_list,
    },
  });
  return await res.message.results[0].channel;
}

async function leave_contributor(params) {
  const {
    parent_channel,
    user,
    user_email,
    creation_date = null,
    last_active_sub_channel = null,
    user_to_remove = null,
    empty_contributor_list = 0,
    freeze = false,
  } = params;
  await frappe.call({
    method: "clefincode_chat.api.api_1_2_1.api.leave_contributor",
    args: {
      parent_channel: parent_channel,
      user: user,
      user_email: user_email,
      creation_date: creation_date,
      last_active_sub_channel: last_active_sub_channel,
      user_to_remove: user_to_remove,
      empty_contributor_list: empty_contributor_list,
    },
  });
}

async function remove_reference_doctype(
  chat_topic,
  reference_doctype,
  chat_channel,
  last_active_sub_channel
) {
  const res = await frappe.call({
    method: "clefincode_chat.api.api_1_2_1.api.remove_reference_doctype",
    args: {
      chat_topic: chat_topic,
      reference_doctype: reference_doctype,
      chat_channel: chat_channel,
      last_active_sub_channel: last_active_sub_channel,
    },
  });
  return await res.message;
}

async function get_topic_contributors(chat_topic) {
  const res = await frappe.call({
    method: "clefincode_chat.api.api_1_2_1.api.get_topic_contributors",
    args: {
      chat_topic: chat_topic,
    },
  });
  return await res.message;
}
